/**
 * bootprompt.js locale configuration
 * locale : Slovak
 * author : Stano Paška
 */

import { addLocale } from "../bootprompt";

addLocale("sk", {
  OK: "OK",
  CANCEL: "Zrušiť",
  CONFIRM: "Potvrdiť",
});
